<h1 mat-dialog-title>Edit Tag</h1>
<div mat-dialog-content>
    <form [formGroup]="form">
        <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-stroked-button color="primary" (click)="save()">Save</button>
</div>
